import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetLocationsByIdsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type GetLocationsByIdsQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: number, name?: string | null, nickname?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, phone?: string | null }> };


export const GetLocationsByIdsDocument = gql`
    query getLocationsByIds($ids: [bigint!]!) {
  locations(where: {id: {_in: $ids}}) {
    id
    name
    nickname
    address
    latitude
    longitude
    phone
  }
}
    `;

/**
 * __useGetLocationsByIdsQuery__
 *
 * To run a query within a React component, call `useGetLocationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetLocationsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables> & ({ variables: GetLocationsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>(GetLocationsByIdsDocument, options);
      }
export function useGetLocationsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>(GetLocationsByIdsDocument, options);
        }
// @ts-ignore
export function useGetLocationsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>;
export function useGetLocationsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationsByIdsQuery | undefined, GetLocationsByIdsQueryVariables>;
export function useGetLocationsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>(GetLocationsByIdsDocument, options);
        }
export type GetLocationsByIdsQueryHookResult = ReturnType<typeof useGetLocationsByIdsQuery>;
export type GetLocationsByIdsLazyQueryHookResult = ReturnType<typeof useGetLocationsByIdsLazyQuery>;
export type GetLocationsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsByIdsSuspenseQuery>;
export type GetLocationsByIdsQueryResult = Apollo.QueryResult<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getLocationsByIds.query.gql}
 */
export async function getLocationsByIds(
  variables: GetLocationsByIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLocationsByIdsQuery['locations']>
export async function getLocationsByIds(
  variables: GetLocationsByIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLocationsByIdsQuery>
export async function getLocationsByIds(
  variables: GetLocationsByIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLocationsByIdsQuery['locations'] | GetLocationsByIdsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLocationsByIdsQuery>(
    GetLocationsByIdsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations
}